export default {
  basicInfo: {}
}